export class TenantSSOError extends Error {
    constructor(reason) {
        super(reason);
        this.reason = reason;
        this.name = "TenantSSOError";
    }
}
//# sourceMappingURL=errors.js.map